import { handleActions } from "redux-actions";
import { RECEIVE_SEARCH } from "../../search/constants";
import { UPDATE_CLIENT_WIDTH } from "../../layout/constants";
import receiveProducts from "./receiveProducts";
import updateSizeMappingIndex from "./updateSizeMappingIndex";

const initialState = {
  isDisplayed: false,
  sizeMappingIndex: null
};

export const reducer = handleActions(
  {
    [RECEIVE_SEARCH]: receiveProducts,
    [UPDATE_CLIENT_WIDTH]: updateSizeMappingIndex
  },
  initialState
);
